function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21 88c0-27 22-49 49-49h391c27 0 48 22 48 49s-22 49-48 49H70c-27 0-49-22-49-49zm0 176c0-27 22-48 49-48h391c27 0 48 21 48 48s-22 49-48 49H70c-27 0-49-21-49-49zm0 177c0-27 22-49 49-49h286c26 0 48 21 48 49 0 26-21 48-48 48H70c-27 0-49-21-49-48z"
}));